<template>
  <div class="value-input"
        data-input-name="name"
        data-input-type="calculated"
        :data-input-value="value">
    <div class="field columns">
      <div class="field-label column">
        <label :data-tooltip="tooltip">{{title}}</label>
      </div>
      <div class="field-body column">
        <div class="control">
          <label>{{value}}</label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Tooltip from '../atoms/Tooltip'

  export default {
    name: 'CalculatedValueInput',
    components: {
      Tooltip
    },
    props: {
      name: String,
      title: String,
      tooltip: String,
      value: Number,
    },
  }
</script>
